export enum UnitType {
    STUDIO = 'Studio',
    ACCESSIBLE_STUDIO = 'Accessible Room',
    CLASSIC = 'Classic',
    CLASSIC_COURTYARD = 'Classic Courtyard',
    CLASSIC_PLUS = 'Classic Plus',
    CLUSTER = 'Cluster',
    DELUXE = 'Deluxe',
    LITE = 'Lite',
    LITE_PLUS = 'Lite Plus',
    PREMIUM = 'Premium',
    PREMIUM_PLUS = 'Premium Plus',
    THREE_BEDROOM = 'Three Bedroom',
    TWIN_ROOM = 'Twin Room',
    TWO_BEDROOM = 'Two Bedroom',
    ULTIMATE_VITA = 'Ultimate Vita',
    ONE_BEDROOM = 'One Bedroom',
    DUO = 'Duo',
    CLASSIC_NOMS = 'Classic Noms',
    LITE_NOMS = 'Lite Noms',
    LITE_PLUS_NOMS = 'Lite Plus Noms',
    DUO_NOMS = 'Duo Noms',
    ULTIMATE = 'Ultimate',
    ULTIMATE_NOMS = 'Ultimate Noms',
    ENHANCED_NOMS = 'Enhanced Noms',
    ESSENTIAL_NOMS = 'Essential Noms',
    ESSENTIAL_EXTRA_NOMS = 'Essential Extra Noms',
    ELITE_NOMS = 'Elite Noms',
    ESSENTIAL = 'Essential',
    ENHANCED = 'Enhanced',
    ELITE = 'Elite',
    ESSENTIAL_EXTRA = 'Essential Extra',
    QUAD_LARGE = 'Quad Large',
    STANDARD_STUDIO = 'Standard Studio',
    STANDARD_QUAD = 'Standard Quad',
    TRIO = 'Trio',
    XL_STUDIO_ACCESSIBLE = 'XL Studio Accessible',
    LARGE_STUDIO = 'Large Studio',
    XL_STUDIO_ADAPTABLE = 'XL Studio Adaptable',
    XL_STUDIO = 'XL Studio',
    XXL_STUDIO = 'XXL Studio',
    DELUXE_PLUS = 'Deluxe Plus',
}
